'use strict';

export default class {
  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  

}



// WEBPACK FOOTER //
// ./client/app/reports/reports.controller.js